module.exports = __webpack_public_path__ + "static/media/country_french_laundry_1.c04d13d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/country_french_laundry_1.jpg
// module id = 151
// module chunks = 0